import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { getBreadcrumbs } from "~/locationMaps/pageMappings";

/** Route-driven breadcrumb trail resolved from the page-mapping registry. */
const Breadcrumbs = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const crumbs = getBreadcrumbs(pathname);

	if (crumbs.length === 0) return null;

	return (
		<MuiBreadcrumbs aria-label="breadcrumb" sx={{ px: { sm: 3, xs: 2 }, py: 1 }}>
			{crumbs.map((crumb, index) => {
				const isLast = index === crumbs.length - 1;
				if (isLast) {
					return (
						<Typography key={crumb.link} color="text.primary" variant="body2">
							{crumb.label}
						</Typography>
					);
				}
				return (
					<Link
						key={crumb.link}
						color="inherit"
						component="button"
						onClick={() => navigate(crumb.link)}
						underline="hover"
						variant="body2"
					>
						{crumb.label}
					</Link>
				);
			})}
		</MuiBreadcrumbs>
	);
};

export default Breadcrumbs;
